import React, { useEffect, useRef, useState } from 'react';
import YarnContractService from '../../services/yarn-contract.service';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import './setup-list.scss'
import HardDelete from '../hard-delete/hard-delete';
// import AuditTableInput from '../audit-table/audit-table';
import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  PdfExport,
  PdfExportProperties,
  ExcelExport,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  ColumnDirective,
  ColumnsDirective,
  DialogEditEventArgs,
  Group,
  Freeze,
  ColumnChooser,
  Reorder
} from '@syncfusion/ej2-react-grids';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import SetupService from '../../services/setup.service';
import moment from 'moment';
import SecurityService from '../security/security.service';
import CommonService from '../../services/common.service';
import CheckDuplicate from '../check-duplicate/check-duplicate';
import { Description } from '@material-ui/icons';
import AuditTableInput from '../audit-table/audit-table';
let selectedRows  = []
let setupData = []
export default function SetupList(props) {
  
  const [setup, setSetup] = useState([]);
  const [title, setTitle] = useState('');
  const [table, setTable] = useState('');
  const [tableName, setTableName] = useState('');
  const [tableID, setTableID] = useState('');
  const [deleteDialogVisibility, setDeleteDialogVisibility] = useState(false);
  const [dialogWarningVisibility, setDialogWarningVisibility] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const [deletingID, setDeletingID] = useState(0);
  const [value, setValue] = useState('');
  const deleteDialog = useRef();
  const warningDialog = useRef();  
  const [showDialogs, setShowDialogs] = useState();
  const [deletingProps, setDeletingProps] = useState();
  const isDuplicate = useRef(false);  
  const UserId = SecurityService.getLoggedInUserId();
  const CompanyID = SecurityService.getCompanyIDLoggedInUserId();


useEffect(()=>{
  setupData = setup

},[setup])

const CheckDup =  ( )=>{
  duplicateState =  CheckDuplicate.withCombination(setupData,['value'],{value : descriptionRef.current.value})
  return duplicateState;

}

  let setupGrid: Grid;
  var descriptionRef =  useRef();
  var duplicateState = false
  const setHeading = () => {
    const type = setupType();
    let title: string;
    let table: string;
    let tableId : string;
    let tablenName: string;
    switch (type) {
      case 'Broker':
        title = 'Broker';
        table = 'Brokers'
        tableId = ''
        tablenName = ''
        break;
      case 'UnitOfMeasurement':
        title = 'Unit Of Measurement';
        table = 'UnitOfMeasurement';
        tableId = 'UnitOfMeasurementID';
        tablenName = 'UnitOfMeasurement';

        break;
      case 'AccountCategory':
        title = 'Account Category';
        table = 'AccountCategory';
        tableId = 'AccountCategoryID';
        tablenName = 'AccountCategory';

        break;

        case 'YarnCount':
        title = 'Yarn Count';
        table = 'YarnCountInfo';
        tableId = 'YarnCountID';
        tablenName = 'YarnCountInfo';
        break;


        case 'YarnQuality':
        title = 'Yarn Quality';
        table = 'YarnQualityInfo';
        tableId = 'YarnQualityID';
        tablenName = 'YarnQualityInfo';
        break;

        case 'YarnType':
          title = 'Yarn Type';
          table = 'YarnTypeInfo';
          tableId = 'YarnTypeID';
          tablenName = 'YarnTypeInfo';
          break;
  
        case 'YarnBrand':
          title = 'Yarn Brand';
          table = 'YarnBrandInfo';
          tableId = 'YarnBrandID';
          tablenName = 'YarnBrandInfo';
          break;
    
        case 'AccessoryType':
          title = 'Accessory Type';
          table = 'AccessoryTypeInfo';
          tableId = 'AccessoryTypeID';
          tablenName = 'AccessoryTypeInfo';
          break;

        case 'Country':
          title = 'Country';
          table = 'CountryInfo';
          tableId = 'CountryID';
          tablenName = 'CountryInfo';
          break;

        case 'Port':
          title = 'Port';
          table = 'PortInfo';
          tableId = 'PortID';
          tablenName = 'PortInfo';
          break;

        case 'Currency':
          title = 'Currency';
          table = 'CurrencyInfo';
          tableId = 'CurrencyID';
          tablenName = 'CurrencyInfo';
          break;

        case 'ShipmentTerms':
          title = 'Shipment Terms';
          table = 'ShipmentTermsInfo';
          tableId = 'ShipmentTermsID';
          tablenName = 'ShipmentTermsInfo';
          break;
  
        case 'Packing':
          title = 'Packing';
          table = 'PackingInfo';
          tableId = 'PackingID';
          tablenName = 'PackingInfo';
          break;

        case 'ContractType':
          title = 'Contract Type';
          table = 'ContractTypeInfo';
          tableId = 'ContractTypeID';
          tablenName = 'ContractTypeInfo';
          break;

        case 'Color':
          title = 'Color';
          table = 'ColorInfo';
          tableId = 'ColorID';
          tablenName = 'ColorInfo';
          break;

        case 'ProductSize':
          title = 'Product Size';
          table = 'ProductSizeInfo';
          tableId = 'ProductSizeID';
          tablenName = 'ProductSizeInfo';
          break;

        case 'Fancy':
          title = 'Fancy';
          table = 'FancyInfo';
          tableId = 'FancyID';
          tablenName = 'FancyInfo';
          break;

        case 'Unit':
          title = 'Unit';
          table = 'UnitInfo';
          tableId = 'UnitID';
          tablenName = 'UnitInfo';
          break;

        case 'DeliveryStatus':
          title = 'Delivery Status';
          table = 'DeliveryStatusInfo';
          tableId = 'DeliveryStatusID';
          tablenName = 'DeliveryStatusInfo';
          break;

        case 'Godown':
          title = 'Godown';
          table = 'GodownInfo';
          tableId = 'GodownID';
          tablenName = 'GodownInfo';
          break;

        case 'Designation':
          title = 'Designation';
          table = 'DesignationInfo';
          tableId = 'DesignationID';
          tablenName = 'DesignationInfo';
          break;

        case 'Softness':
          title = 'Softness';
          table = 'SoftnessInfo';
          tableId = 'SoftnessID';
          tablenName = 'SoftnessInfo';
          break;

        case 'DryProcess':
          title = 'Dry Process';
          table = 'DryProcessInfo';
          tableId = 'DryProcessID';
          tablenName = 'DryProcessInfo';
          break;

        case 'Process':
          title = 'Process';
          table = 'ProcessInfo';
          tableId = 'ProcessID';
          tablenName = 'ProcessInfo';
          break;

        case 'ReProcess':
          title = 'ReProcess';
          table = 'ReProcessInfo';
          tableId = 'ReProcessID';
          tablenName = 'ReProcessInfo';
          break;

        case 'ProcessDesc':
          title = 'Process Description';
          table = 'ProcessDescInfo';
          tableId = 'ProcessDescID';
          tablenName = 'ProcessDescInfo';
          break;

        case 'LoomType':
          title = 'Loom Type';
          table = 'LoomTypeInfo';
          tableId = 'LoomTypeID';
          tablenName = 'LoomTypeInfo';
          break;

        case 'SewingType':
          title = 'Sewing Type';
          table = 'SewingTypeInfo';
          tableId = 'SewingTypeID';
          tablenName = 'SewingTypeInfo';
          break;

      // For Property Projec

          case 'Property':
    title = 'Property';
    table = 'Property';
    tableId = 'PropertyID';
    tablenName = 'Property';
    break;

case 'PropertyUsageType':
    title = 'Property Usage Type';
    table = 'PropertyUsageType';
    tableId = 'PropertyUsageTypeID';
    tablenName = 'PropertyUsageType';
    break;

case 'Building':
    title = 'Building';
    table = 'Building';
    tableId = 'BuildingID';
    tablenName = 'Building';
    break;

case 'PropertyLocation':
    title = 'Property Location';
    table = 'PropertyLocation';
    tableId = 'PropertyLocationID';
    tablenName = 'PropertyLocation';
    break;

case 'PropertyFloor':
    title = 'Property Floor';
    table = 'PropertyFloor';
    tableId = 'PropertyFloorID';
    tablenName = 'PropertyFloor';
    break;

case 'PropertyUnitType':
    title = 'Property Unit Type';
    table = 'PropertyUnitType';
    tableId = 'PropertyUnitTypeID';
    tablenName = 'PropertyUnitType';
    break;

case 'CostCenter':
    title = 'Cost Center';
    table = 'CostCenter';
    tableId = 'CostCenterID';
    tablenName = 'CostCenter';
    break;

    case 'ProductCategory':
      title = 'Product Category';
      table = 'ProductCategory';
      tableId = 'ProductCategoryID';
      tablenName = 'ProductCategory';
      break;
  

case 'Nationality':
    title = 'Nationality';
    table = 'Nationality';
    tableId = 'NationalityID';
    tablenName = 'Nationality';
    break;

case 'ModeOfPayment':
    title = 'Mode of Payment';
    table = 'ModeOfPayment';
    tableId = 'ModeOfPaymentID';
    tablenName = 'ModeOfPayment';
    break;



      case 'AccountCategory':
        title = 'Account Category';
        table = 'AccountCategory';
        tableId = 'AccountCategoryID';
        tablenName = 'AccountCategory';
        break;
      case 'FabricAdjustmentType':
        title = 'Fabric Adjustment Type';
        table = 'FabricAdjustmentType';
        tableId = 'FabricAdjustmentTypeID';
        tablenName = 'FabricAdjustmentType';
        break;
      case 'FabricVersion':
        title = 'Fabric Version';
        table = 'FabricVersion';
        tableId = 'FabricVersionID';
        tablenName = 'FabricVersion';
        break;
      case 'FabricDesign':
        title = 'Fabric Design';
        table = 'FabricDesign';
        tableId = 'FabricDesignID';
        tablenName = 'FabricDesign';
        break;
      case 'YarnGodown':
        title = 'Yarn Godown';
        table = 'Godown';
        tableId = 'GodownID';
        tablenName = 'GodownName';
        break;
      case 'Department':
        title = 'Department';
        table = 'Department';
        tableId = 'DepartmentID';
        tablenName = 'DepartmentName';
        break;
      case 'Port':
        title = 'Port';
        table = 'Port';
        tableId = 'PortID';
        tablenName = 'PortName';
        break;
      case 'ImportLC':
        title = 'Import LC';
        table = 'ImportLC';
        tableId = 'ImportLCID';
        tablenName = 'ImportLCNo';
        break;
      case 'HSCode':
        title = 'HS Code';
        table = 'HSCode';
        tableId = 'HSCodeID';
        tablenName = 'HSCodeNo';
        break;
      case 'FabricType':
        title = 'Fabric Type';
        table = 'FabricType';
        tableId = 'FabricTypeID';
        tablenName = 'FabricTypeDesc';
        break;
      case 'FabricYarnDescription':
        title = 'Fabric Yarn Description';
        table = 'FabricYarnDescription';
        tableId = 'FabricYarnDescID';
        tablenName = 'FabricYarnDesc';
        break;
      case 'FabricCategory':
        title = 'Fabric Category';
        table = 'FabricCategory';
        tableId = 'FabricCategoryID';
        tablenName = 'FabricCategoryDesc';
        break;
      case 'FabricThreadCount':
        title = 'Fabric Thread Count';
        table = 'FabricThreadCount';
        tableId = 'FabricThreadCountID';
        tablenName = 'FabricThreadCountDesc';
        break;
      case 'Vendors':
        title = 'Vendors';
        table = 'Company';
        tableId = 'CompanyID';
        tablenName = 'CompanyName';
        break;
      case 'CompanyType':
        title = 'Company Type';
        table = 'CompanyType';
        tableId = 'CompanyTypeID';
        tablenName = 'CompanyType';
        break;
      case 'Currency':
        title = 'Currency';
        table = 'Currency';
        tableId = 'CurrencyID';
        tablenName = 'CurrencyName';
        break;
      case 'ImportExpenses':
        title = 'Import Expenses';
        table = 'ImportExpenses';
        tableId = 'ImportExpensesID';
        tablenName = 'ImportExpenses';
        break;
      case 'FabricPacking':
        title = 'Fabric Packing';
        table = 'FabricPacking';
        tableId = 'FabricPackingID';
        tablenName = 'FabricPacking';
        break;
      case 'DeliveryStatus':
        title = 'Delivery Status';
        table = 'DeliveryStatus';
        tableId = 'DeliveryStatusID';
        tablenName = 'DeliveryStatus';
        break;
      case 'ConversionContractType':
        title = 'Conversion Contract Type';
        table = 'ConversionContractType';
        tableId = 'ConversionContractTypeID';
        tablenName = 'ConversionContractType';
        break;
      case 'BrokerageType':
        title = 'Brokerage Type';
        table = 'BrokerageType';
        tableId = 'BrokerageTypeID';
        tablenName = 'BrokerageType';
        break;
      case 'ProcurementType':
        title = 'Procurement Type';
        table = 'ProcurementType';
        tableId = 'ProcurementTypeID';
        tablenName = 'ProcurementType';
        break;
      case 'AccessoryCategory':
        title = 'Accessory Category';
        table = 'AccessoryCategory';
        tableId = 'AccessoryCategoryID';
        tablenName = 'AccessoryCategory';
        break;
      case 'Unit':
        title = 'Unit';
        table = 'UnitOfMeasurement';
        tableId = 'UnitOfMeasurementID';
        tablenName = 'UnitOfMeasurement';
        break;
      case 'ProductCategory':
        title = 'Product Category';
        table = 'ProductCategory';
        tableId = 'ProductCategoryID';
        tablenName = 'ProductCategory';
        break;
      case 'RejectionCategory':
        title = 'Rejection Category';
        table = 'RejectionCategory';
        tableId = 'RejectionCategoryID';
        tablenName = 'RejectionCategory';
        break;
      case 'RejectionSubCategory':
        title = 'Rejection Sub Category';
        table = 'RejectionSubCategory';
        tableId = 'RejectionSubCategoryID';
        tablenName = 'RejectionSubCategory';
        break;
        case 'AccountType':
          title = 'AccountType';
          table = 'AccountType';
          tableId = 'AccountTypeID';
          tablenName = 'AccountType';
          break;
      case 'ProductDesc':
        title = 'Product Desc';
        table = 'ProductDesc';
        tableId = 'ProductDescID';
        tablenName = 'ProductDesc';
        break;
      case 'ProcessDesc':
        title = 'Process Desc';
        table = 'ProcessDesc';
        tableId = 'ProcessDescID';
        tablenName = 'ProcessDesc';
        break;
      case 'PaymentTerms':
        title = 'Payment Terms';
        table = 'PaymentTerms';
        tableId = 'PaymentTermsID';
        tablenName = 'PaymentTerms';
        break;
      case 'Designation':
        title = 'Designation';
        table = 'Designation';
        tableId = 'DesignationID';
        tablenName = 'Designation';
        break;
      case 'MadeupProductionLocalSaleActivityType':
        title = 'MadeupProductionLocalSaleActivityType';
        table = 'MadeupProductionLocalSaleActivityType';
        tableId = 'MadeupProductionLocalSaleActivityTypeID';
        tablenName = 'MadeupProductionLocalSaleActivityType';
        break;
      default:
        title = 'UnitOfMeasurement';
        table = 'UnitOfMeasurement';
        tableId = 'UnitOfMeasurementID';
        tablenName = 'UnitOfMeasurement';
        break;
    }
    setTitle(title);
    setTable(table);
    setTableID(tableId);
    setTableName(tablenName);
  };

  useEffect(() => {
    setHeading();
    const type = setupType();
    getSetup(type);
  }, []);

  const getSetup = async (type) => {
    SetupService.getForList(type)
      .then((response) => {
        setSetup(response.data.recordset);
        setupData = response.data.recordset;
        selectedRows = []
      })
      .catch((e) => {
        console.log(e);
        setSetup({});
      });
  };

  const setupType = () => {
    return window.location.pathname
      .substr(1, window.location.pathname.length)
      .split('/')[1];
  };

  const getRoute = () =>
    window.location.pathname
      .substr(1, window.location.pathname.length)
      .split('/');


      
  const toolbarOptions: ToolbarItems[] = [
    'Add',
    'Edit',
    {
      text: "Delete", tooltipText: "Delete", id: "Delete", disabled: ! SecurityService.canUserAccess(`${setupType()}Delete`)
    },
    //  'Delete',
    'Update',
    // {
    //   text: "Update",
    //   tooltipText: "Update",D
    //   id: "Update",
    //   disabled: isDuplicate.current,
    // },
    'Cancel',
    'PDFExport',
    'ExcelExport',
    'Search',
    //'ColumnChooser',
  ];

  const userId = SecurityService.getLoggedInUserId();
  const databound = () =>
  {
      if (setupGrid) {
        // setupGrid.autoFitColumns();
      }
  }


  const toolbarClick = (args: ClickEventArgs) => {
    console.log('toolbar click: ', args);
    if (setupGrid && args.item.properties.id === 'setupGrid_PDFExport') {
      const heading = setupType().match(/[A-Z][a-z]+/g).join("_");
      const exportProperties: PdfExportProperties = {
        pageOrientation: 'Landscape',
        fileName: `${moment().format('YYYYMMDD')}_setup_${heading.toLowerCase()}.pdf`
      };
      console.log('clicked on pdf export');
      setupGrid.pdfExport(exportProperties);
    }
    if (setupGrid && args.item.properties.id === 'setupGrid_excelexport') {
      const heading = setupType().match(/[A-Z][a-z]+/g).join("_");
      const exportProperties: PdfExportProperties = {
        fileName: `${moment().format('YYYYMMDD')}_setup_${heading.toLowerCase()}.xlsx`
      };
      setupGrid.excelExport(exportProperties);
    }
    // if (setupGrid && args.item.properties.id === 'Delete') {
    //   console.log('toolbar Delete');
    //   if (setupGrid.selectedRowIndex === -1) {
    //     // no rows selected
    //     setDialogWarningVisibility(true);
    //   } else {
    //     setDeleteDialogVisibility(true);
    //   }
    // }    
    // if (setupGrid && args.item.properties.id === 'Delete') {
    //   console.log('toolbar Delete');
    //   if (setupGrid.selectedRowIndex === -1) {
    //     // no rows selected
    //     console.log('Delete ', setupGrid.getSelectedRecords()[0]);
    //     // setDialogWarningVisibility(false);
    //     setWarningMessage('Please select a row first!');
    //     warningDialog.current.show();
    //   } else {
    //     console.log('delete: ', setupGrid.getSelectedRecords()[0]?.id)
    //     // deleteDialog.current.hide();
    //     setDeletingID(setupGrid.getSelectedRecords()[0]?.id);
    //     deleteDialog.current.show();
    //   }
    // }
    if (setupGrid && args.item.properties.id === 'Delete') {
      console.log('toolbar Delete');
      if (setupGrid.selectedRowIndex === -1) {
        // no rows selected
        console.log('Delete ', setupGrid.getSelectedRecords()[0]);
        // setDialogWarningVisibility(false);
        let obj={
          TableName:`ProcessDesc`,
          ColumnName:`ProcessDescID`,
          RowID:undefined,
          SelectedRow:false,
          UserID:UserId,
          // DeleteSecurity:`ProcessDescDelete`
          
        }
        setDeletingProps(obj)
        setShowDialogs(true)
       
      } else {
        console.log('delete: ', setupGrid.getSelectedRecords()[0]?.id)
        // deleteDialog.current.hide();
        let obj={
          TableName:table,
          ColumnName:tableID,
          RowID:setupGrid.getSelectedRecords()[0]?.id,
          SelectedRow:true,
          UserID:UserId,
          // DeleteSecurity:`FabricQualityDelete`,
          SelectedRowData :{
           [tableName] :  setupGrid.getSelectedRecords()[0]?.value
              }
          
          
          
          }
          setDeletingProps(obj)
        
        // deleteDialog.current.show();
        setShowDialogs(true)
      }
    }
  };

  const editSettings: EditSettingsModel = {
    allowEditing: SecurityService.canUserAccess(`${setupType()}Edit`),
    allowAdding: SecurityService.canUserAccess(`${setupType()}Add`),
    allowDeleting: SecurityService.canUserAccess(`${setupType()}Delete`),

    // allowEditing: true,
    // allowAdding: true,
    // allowDeleting: true,

    mode: 'Normal',
    // showDeleteConfirmDialog: true,
  };

  const filterOptions: FilterSettingsModel = {
    type: 'Excel',
    // columns: [
    //   {
    //     field: 'IsDeleted',
    //     operator: 'notequal',
    //     value: 'True'
    //   }
    // ]
  };

  const groupOptions: GroupSettingsModel = {
    showDroopArea: true,
  };

  const sortingOptions: SortSettingsModel = {
    columns: [{ field: 'id', direction: 'Descending' }]
  }

  const actionComplete = (args: DialogEditEventArgs) => {
    // console.log('data: ', args);
    if (args?.requestType === 'columnstate') {
      console.log('adjusting column');
      setupGrid?.autoFitColumns();
    }
    if (args.form) {
      // console.log('data: ', args);
      if (args.requestType === 'beginEdit' || args.requestType === 'add' ) {

        console.log('e: ', args.form.ej2_instances[0]);
        /** Add Validation Rules */
        // args.form.ej2_instances[0].addRules('OrderID', { max: 500 });

        // args.form.ej2_instances[0].addRules('OrderDate', {
        //   required: true,
        //   date: true,
        // });
        // args.form.ej2_instances[0].addRules('ContractStartDate', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('ContractEndDate', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('CompanyID', { required: true });
        // args.form.ej2_instances[0].addRules('FullYarnCountID', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('BrandID', { required: true });
        // args.form.ej2_instances[0].addRules('ImportLCID', { required: true });
        // args.form.ej2_instances[0].addRules('OrderBags', { required: true });
        // args.form.ej2_instances[0].addRules('WeightPerBag', { required: true });
        // args.form.ej2_instances[0].addRules('YarnProcurementTypeID', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('CurrencyID', { required: true });
        // args.form.ej2_instances[0].addRules('ForeignCurrencyRate', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('ForeignCurrencyAmount', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('ContractExchangeRate', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('Rate', { required: true });
        // args.form.ej2_instances[0].addRules('RatePer', { required: true });

        // args.form.ej2_instances[0].addRules('TaxTypeID', { required: true });
        // args.form.ej2_instances[0].addRules('TaxPercent', { required: true });
        // args.form.ej2_instances[0].addRules('PaymentTermsID', {
        //   required: true,
        // });

        // args.form.ej2_instances[0].addRules('DeliveryStatusID', {
        //   required: true,
        // });

        // args.form.ej2_instances[0].addRules('PaymentDays', {
        //   required: true,
        // });
      }

      if (args.requestType === 'save' && args.action == 'edit') {
        const type = getRoute()[1];
        SetupService.update(type, {...args.data , value :value}).then((response) => {
          console.log('edit response: ', response);
          console.log([tableName],selectedRows,{[tableName] :value},type,args.data.id)
          // let totalColumns = Object.keys(EditData);
          // console.log(totalColumns)
          // AuditTableInput.auditEdit(totalColumns,selectedRows,EditData,`ProductFinishSize`,args.data.ProductFinishSizeID)
          AuditTableInput.auditEdit([tableName],{[tableName] :selectedRows.value},{[tableName] :value},type,args.data.id)
    setTimeout(() => {
      // selectedRows = []
      getSetup(type);
    }, 500);
        });
        // if (args?.data?.id > 0) {
        //   editSetup(type, args?.data);

        // }
        // else {
        //   console.log(args.data)
        //   addSetup(type, args?.data)
        // }
      }
      if(args.requestType == 'save' && args.action == 'add'){
        console.log(args.data)
        const type = getRoute()[1];
          addSetup(type, args?.data)
      }


    }
  };


  const addSetup = (type: string, data: any) => {
    console.log( value)
    SetupService.insert(type,  {...data , CompanyID, value:value}).then((response) => {
      console.log('add response: ', response);
      // AuditTableInput.auditAdd(table,table,tableID,{ [tableName]:value})

      setSetup(response.data.recordset);
      //getSetup(type);        
    });
  };

  const editSetup = (type: string, data: any) => {
    SetupService.update(type, {...data , value :value}).then((response) => {
      console.log('edit response: ', response);
      console.log([tableName],selectedRows,{[tableName] :value},type,data.id)
      // AuditTableInput.auditEdit([tableName],selectedRows,{[tableName] :value},type,data.id)

      getSetup(type);
    });
  };

  const DELETE_MESSAGE = "DELETED SUCCESSFULLY";
  const CONFLICT_MESSAGE = "CONFLICT IN DATABASE";
  const deleteRow = () => {
    const type = getRoute()[1];
    SetupService.delete(type , deletingID)
      .then((response) => {
        console.log(response);
        setWarningMessage(DELETE_MESSAGE);
        warningDialog.current.show();
      })
      .catch((e) => {
        setWarningMessage(CONFLICT_MESSAGE);
        warningDialog.current.show();
      });
  };

  const deleteButtons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: (e) => {
        deleteDialog.current.hide();
        console.log(e);
        deleteRow();
      },
    },
    {
      buttonModel: {
        content: "Cancel",
        cssClass: "e-flat",
      },
      click: () => {
        deleteDialog.current.hide();
      },
    },
  ];

  const warningButtons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        warningDialog.current.hide();
        // setTimeout(() => {
        //   if (!(warningMessage.includes('access denied'))) {
        //     // record was succesfully deleted
        //     const type = getRoute()[1];
        //     getYarnContracts(type);
        //     // console.log("record was succesfully deleted");
        //   }
        // }, 500);
      },
    },
  ];

  function deleteDialogClose() {
    setDeleteDialogVisibility(false);
  }

  function warningDialogClose() {
    setDialogWarningVisibility(false);
    if (warningMessage.includes(DELETE_MESSAGE)) {
      const type = setupType();
      setHeading();
      getSetup(type);
      }
  }



  return (
    <div className="content-wrapper" onKeyDown={(e)=>{
      console.log(isDuplicate.current)
      if(isDuplicate.current == true){
      e.stopPropagation()
      }
    }}>
      <div>
      <div>
      <DialogComponent
        ref={deleteDialog}
        width={500}
        visible={deleteDialogVisibility}
        close={deleteDialogClose}
        content={() => <div>Are you sure you want to delete?</div>}
        isModal={true}
        header="Confirmation"
        buttons={deleteButtons}
      // footerTemplate={footerTemplate}
      />
      <DialogComponent
        ref={warningDialog}
        width={400}
        visible={dialogWarningVisibility}
        close={warningDialogClose}
        content={() => <div>{warningMessage}</div>}
        isModal={true}
        header="Warning"
        buttons={warningButtons}
      // footerTemplate={footerTemplate}
      />
    </div>
        <div>
          <h3> {title} - List</h3>
          <div></div>
          <DialogComponent
                ref={deleteDialog}
                width={500}
                visible={deleteDialogVisibility}
                close={deleteDialogClose}
                content={() => (<div>Are you sure you want to delete?</div>)}
                isModal={true}
                header='Confirmation'
                buttons={deleteButtons}
              // footerTemplate={footerTemplate}
              />
              <DialogComponent
                ref={warningDialog}
                width={400}
                visible={dialogWarningVisibility}
                close={warningDialogClose}
                content={() => (<div>{warningMessage}</div>)}
                isModal={true}
                header='Warning'
                buttons={warningButtons}
              // footerTemplate={footerTemplate}
              />            
          <GridComponent
            ref={(grid) => (setupGrid = grid)}
            id='setupGrid'
            //height = {550}
            //width = {900}
            dataSource={setup}
            editSettings={editSettings}
            toolbar={toolbarOptions}
            pageSettings={{ pageCount: 4, pageSizes: true }}
            filterSettings={filterOptions}
            groupSettings={groupOptions}
            actionComplete={actionComplete}
            allowTextWrap='true'
            allowPaging={true}
            allowSorting={true}
            allowPdfExport={true}
            allowExcelExport={true}
            toolbarClick={toolbarClick}
            allowFiltering={true}
            allowGrouping={true}
            //showColumnChooser={true}
            allowReordering={true}
            allowResizing={true}
            sortSettings={sortingOptions}
            dataBound={databound}
            rowSelected={
              (args)=>{
                console.log(args.data)
                console.log(selectedRows)
                if(selectedRows.length < 1){
               selectedRows = args.data;
               }
                
                          setTimeout(() => {
                  console.log('ss')
                }, 200);
              }
            }
           
          >
            <ColumnsDirective>
              <ColumnDirective
                headerText='ID'
                field='id'
                width='10'
                headerTextAlign='Center'
                textAlign='Right'
                allowEditing={false}
              />
              <ColumnDirective
                headerText='Description'
                field='value'
                width='50'
                headerTextAlign='Center'
                textAlign='left'
             
                editTemplate={(props) =>{
                  console.log(props)
                  return (
                  
                  <TextBoxComponent  
                  name='value'
                  ref={descriptionRef}
                  placeholder='Description'
                 value={props.value}
                  
                 
                 id='description'
                
                 created= {()=>{
                
                 setTimeout(() => {
                  return descriptionRef.current.element.focus()
                 }, 200);
                 }}
                 onChange={(e)=>{
                  console.log(e)

                  // let inputColumnName = setupType();
                let     userFeed ={value : e.value}
                  console.log(setupData,['value'],userFeed)
                  const check =CheckDuplicate.withCombination(setupData,['value'],userFeed)
                    
                  if(check){
                    isDuplicate.current = true;
                    let me = document.querySelector('#description');
                    console.log(me)
                    me.style.border= '3px solid red'
                    
                    var setupGridUpdateButton = document.querySelector('#setupGrid_update').parentElement;
                    console.log(setupGridUpdateButton)
setupGridUpdateButton.style.display = 'none';
// setupGridUpdateButton.style.transform = 'scale(0)';
                  }else{
                    console.log(e)
                    setValue(e.value)

                    isDuplicate.current = false;
                   
                    let me = document.querySelector('#description');
                    console.log(me)
                    me.style.border= '2px solid #5CC95E'
                    var setupGridUpdateButton = document.querySelector('#setupGrid_update').parentElement;
                    setupGridUpdateButton.style.display = 'inline-flex';
                    
// setupGridUpdateButton.style.display = 'block';
//                     var setupGridUpdateButton = document.getElementById('setupGrid_update');
// setupGridUpdateButton.style.visibility = 'visible';
// setupGridUpdateButton.style.transform = 'scale(1)';
                  }

                 }}
                 blur={(e)=>{
                  // console.log(check)
                
                  console.log(CheckDup())
                  if(CheckDup()  == true){
                    console.log(isDuplicate)
                    let me = document.querySelector('#description');
                    isDuplicate.current = true;
                   console.log(document.querySelector('#setupGrid_update'))
                   
                  //  setupGridUpdateButton.style.visibility = 'hidden';
                  var setupGridUpdateButton = document.querySelector('#setupGrid_update').parentElement;
                  setupGridUpdateButton.style.display = 'none';
                  //  setupGridUpdateButton.style.transform = 'scale(0)';
                        console.log(me)
                        me.style.border= '3px solid red'
                        // me.targe

                  //  return  descriptionRef.current.element.focus()
                  }else{
                      isDuplicate.current = false;
                      
// setupGridUpdateButton.style.visibility = 'visible';
var setupGridUpdateButton = document.querySelector('#setupGrid_update').parentElement;
setupGridUpdateButton.style.display = 'inline-flex';
// setupGridUpdateButton.style.transform = 'scale(1)';
                    let me = document.querySelector('#description');
                    console.log(me)
                    me.style.border= '2px solid #5CC95E'
                    setTimeout(() => {
                      document.getElementById('setupGrid_update').click();
                    }, 200);
                  }

                 }}
                  
                     />
                )}}
                // template={}
              />
              {/* <ColumnDirective
                headerText='Is Deleted'
                field='IsDeleted'
                width='100'
                allowEditing={false}
              /> */}
            </ColumnsDirective>
            <Inject
              services={[
                Edit,
                Toolbar,
                Page,
                Sort,
                PdfExport,
                ExcelExport,
                Filter,
                Resize,
                Group,
                Freeze,
                //ColumnChooser,
                Reorder,
              ]}
            />
          </GridComponent>
        </div>
      </div>
      {showDialogs ?
          <HardDelete
            {...deletingProps} 
            showResult={(e)=>{
                                console.log(e)

                                setShowDialogs(false)
                                if(e == false){
                                  setShowDialogs(false)
                                  const type = setupType();
                                  getSetup(type);
                                }
              }} 
                ></HardDelete>
                  :null}
    </div>
  );
}